import React from 'react';
import { Link } from 'react-router-dom';
import { Pencil } from 'lucide-react';
import { Button } from '@/src/shadComponents/ui/button';

interface FeatureFlagActionsProps {
    row: any;
}

export default function RoleFeatureFlagAssociationActions({
    row,
}: FeatureFlagActionsProps) {
    const name = row.original.name;
    const roleId = row.original.roleId;

    return (
        <span className="flex items-center gap-2">
            <Link to={`role/${name}/${roleId}`}>
                <Button variant="ghost" size="icon">
                    <Pencil className="size-4" />
                </Button>
            </Link>
        </span>
    );
}
